import type { AuthProfile, LookupAuthProfileRequest } from '@rock/types';
import { getFunctions, httpsCallable } from 'firebase/functions';

/** A Firebase Auth account's name, email and photo, or `null` if the uid has no auth account. */
export async function lookupAuthProfile(request: LookupAuthProfileRequest): Promise<AuthProfile | null> {
    const fn = httpsCallable<LookupAuthProfileRequest, AuthProfile | null>(getFunctions(), 'lookupAuthProfile');
    return (await fn(request)).data;
}
